/**
 * @file Tooltip atom — hover/focus hint overlay family.
 * @description structured atom: compound parts re-exported from the vendored
 * Gluestack family; this is the only sanctioned import path for app code
 * (RFC §3).
 * @module components/atoms/Tooltip
 */
export {
  UITooltip,
  Tooltip,
  TooltipContent,
  TooltipText,
} from "@/components/ui/tooltip";
